import {HttpClient, HttpHeaders} from '@angular/common/http';
import {inject, Injectable} from '@angular/core';
import {UrlService} from "app/core/services/url.service";
import {ErrorHandlingService} from "app/core/services/error.handling.service";
import {BehaviorSubject, Observable, tap} from "rxjs";
import {UrlEnum} from "app/core/types/url-enum";
import {ObservableErrHandler} from "app/core/types/err.handling.types";
import {InvoiceDataPerson} from "../billing.info.types";
import {OrderHistoryDTO} from "./order.history.types";
import {CartProduct} from "../../../../../shared/components/cart/cart.types";


@Injectable({providedIn: 'root'})
export class OrderHistoryService
{
    private readonly _urlService: UrlService = inject(UrlService);
    private readonly _errHandlService: ErrorHandlingService = inject(ErrorHandlingService);
    private readonly _httpClient: HttpClient = inject(HttpClient);
    private readonly _history: BehaviorSubject<OrderHistoryDTO[]> = new BehaviorSubject([]);
    private readonly _busy: BehaviorSubject<boolean> = new BehaviorSubject(false);

    get busy$() {
        return this._busy.asObservable();
    }

    /**
     * Constructor
     */
    constructor() {}

    // -----------------------------------------------------------------------------------------------------
    // @ Accessors
    // -----------------------------------------------------------------------------------------------------

    /**
     * Getter for data
     */
    get history$(): Observable<OrderHistoryDTO[]> {
        return this._history.asObservable();
    }

    // -----------------------------------------------------------------------------------------------------
    // @ Public methods
    // -----------------------------------------------------------------------------------------------------

    /**
     * Get data
     */
    getOrderHistoryFromBE(): void
    {
        // if(this._history.value && this._history.value.length > 0){
        //     //do not get new data if data exists
        //     return;
        // }

        this._busy.next(true);
        const obs = this._httpClient.get<OrderHistoryDTO[]>(
            this._urlService.getUrl(UrlEnum.private_order_history));

        const errWrapper: ObservableErrHandler = {
            observable: obs,
            err_title: "Error"
        };

        this._errHandlService.watchThis(errWrapper);
        errWrapper.observable = errWrapper.observable.pipe(tap({
                next: value => {
                    // anounce new data
                    this._history.next(value);
                },
                error: err => {
                    this._busy.next(false);
                },
                complete: () => {
                    this._busy.next(false);
                }
            }
        ));
        errWrapper.observable.subscribe();
    }

    getOrderDetails(orderID:string):Observable<CartProduct[]> {
        this._busy.next(true);
        const obs = this._httpClient.get<CartProduct[]>(
            this._urlService.getUrl(UrlEnum.private_order_history_details).replace("{orderId}",orderID));

        const errWrapper: ObservableErrHandler = {
            observable: obs,
            err_title: "Error"
        };

        this._errHandlService.watchThis(errWrapper);
        errWrapper.observable = errWrapper.observable.pipe(tap({
                next: value => {
                    this._busy.next(false);
                },
                error: err => {
                    this._busy.next(false);
                },
                complete: () => {
                    this._busy.next(false);
                }
            }
        ));
        return errWrapper.observable;
    }
}
